export enum MeterType {
  HEAT = "HEAT", COLD = "COLD", WATER = "WATER", ELECTRICTY = "ELECTRICTY", GAS = "GAS",
  SANITARY_WATER = "SANITARY_WATER", WIND = "WIND", LUX = "LUX", TEMPERATURE = "TEMPERATURE",
  DEW_POINT = "DEW_POINT", CLOUD_FACTOR = "CLOUD_FACTOR", CHILD = "CHILD_METER",
  CLIMATE_TEMPERATURE = "CLIMATE_TEMPERATURE", CLIMATE_HUMIDITY = "CLIMATE_HUMIDITY",
  CLIMATE_CO2 = "CLIMATE_CO2",
}

export enum MeterTypeSelectable {
  HEAT = "HEAT", COLD = "COLD", WATER = "WATER", ELECTRICTY = "ELECTRICTY", WIND = "WIND", LUX = "LUX", TEMPERATURE = "TEMPERATURE", GAS = "GAS",
  DEW_POINT = "DEW_POINT", CLOUD_FACTOR = "CLOUD_FACTOR", CLIMATE_TEMPERATURE = "CLIMATE_TEMPERATURE", CLIMATE_HUMIDITY = "CLIMATE_HUMIDITY", CLIMATE_CO2 = "CLIMATE_CO2"
}

export enum MeterTypeWeather {
  WIND = "WIND", LUX = "LUX", TEMPERATURE = "TEMPERATURE",
  DEW_POINT = "DEW_POINT", CLOUD_FACTOR = "CLOUD_FACTOR"
}

export enum UnitType {
  Kwh = 'Kwh', M3 = 'M3', Lux = 'lux', degree = 'degree', ms = 'ms', percentage = "percentage", ppm = "ppm", na = "na"
}

export enum IconMeter {
  HEAT = 'local_fire_department',
  COLD = 'ac_unit',
  WATER = 'waves',
  GAS = 'whatshot',
  SANITARY_WATER = 'opacity',
  ELECTRICTY = 'flash_on',
  WIND = 'toys',
  LUX = 'wb_incandescent',
  TEMPERATURE = 'trending_up',
  DEW_POINT = 'invert_colors_on',
  CLOUD_FACTOR = 'cloud',
  CLIMATE_TEMPERATURE = 'device_thermostat',
  CLIMATE_HUMIDITY = 'opacity',
  CLIMATE_CO2 = 'co2',
}

export enum Status {
  active = 'active',
  inactive = 'inactive',
  deleted = 'deleted',
}
